<template>
  <div>
    <BankConnectionModal :mobile-view="isMobileAppView" :show-modal="true" />
  </div>
</template>
<script>
import BankConnectionModal from "@/components/bank/ui/BankConnectionModal";

export default {
  name: "BankConnection",
  components: {
    BankConnectionModal
  },
  props: {

  },
  data () {
    return {

    }
  },
  computed: {
    isMobileAppView () {
      return window.mobile_app_view
    }
  },
  created () {
    if (!this.isMobileAppView) {
      this.$router.push({ name: 'Bank' })
    }
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">

</style>
